import "./Banners.scss";
import "react-status-alert/dist/status-alert.css";
import { useEffect, useState } from "react";
import { Row, Col, Form } from "react-bootstrap";
import Table from "react-bootstrap/Table";
import { Button } from "react-bootstrap";
import moment from "moment";
import { Link } from "react-router-dom";
import { StatusAlertService } from "react-status-alert";
import Simplert from "react-simplert";
import { Paginador } from "../../components/paginador/Paginador";

import {
  activarDesactivarBanner,
  deleteBanner,
  getBanners,
} from "../../Services/BannersService";
import {
  BannerResponse,
} from "../../interfaces/bannerInterfaces";

export const Banners = () => {
  const PAGE_SIZE = 8;
  const [pagActual, setPagActual] = useState<number>(0);

  const [banners, setBanners] = useState<BannerResponse[]>([]);
  const [cargado, setCargado] = useState<boolean>(false);
  const [mostrarAlerta, setMostrarAlerta] = useState<boolean>(false);
  const [bannerBorrar, setBannerBorrar] = useState<number>(0);

  const getAll = () => {
    getBanners().then((response) => {
      if (response.data && response.data.data) {
        setBanners(response.data.data);
        setCargado(true);
      }
    });
  };

  useEffect(() => {
    getAll();
  }, []);

  const activarDesactivar = (idBanner: number) => {
    activarDesactivarBanner(idBanner)
      .then((result) => {
        getAll();
        StatusAlertService.showSuccess("Actualizado Exitosamente");
      })
      .catch(() => {
        StatusAlertService.showError("Error al actualizar");
      });
  };

  const borrarBanner = async (idBanner: number) => {
    setBannerBorrar(idBanner);
    setMostrarAlerta(true);
  };
  const confirmarBorrarBanner = async () => {
    setMostrarAlerta(false);
    deleteBanner(bannerBorrar)
      .then((result) => {
        getAll();
        StatusAlertService.showSuccess("Borrado Exitosamente");
      })
      .catch(({ response }) => {
        const { data } = response;
        StatusAlertService.showError(data.meta.message);
      });
  };

  const bannersMostrar = () =>
    banners.filter(
      (element, i) =>
        i >= PAGE_SIZE * pagActual && i <= PAGE_SIZE * pagActual + PAGE_SIZE - 1
    );

  const cambiarPagina = (pag) => {
    setPagActual(pag);
  };

  return (
    <>
      <Simplert
        showSimplert={mostrarAlerta}
        type="info"
        title="¿Desea eliminar el banner seleccionado?"
        message=""
        customCloseBtnText="Cancelar"
        customConfirmBtnText="Aceptar"
        customConfirmBtnClass="btn-confirm"
        customCloseBtnClass="btn-cerrar"
        disableOverlayClick={true}
        useConfirmBtn={true}
        onConfirm={() => confirmarBorrarBanner()}
        onClose={() => setMostrarAlerta(false)}
      />
      <div className="m-5">
        <Row>
          <Col className="heading-1">Banners</Col>
        </Row>
        <div className="d-flex flex-row-reverse bd-highlight mb-3">
          <Link to={"/banners/0"}>
            <Button variant="primary" className="float-end">
              Crear nuevo Banner
            </Button>
          </Link>
        </div>
        <Table responsive>
          <thead className="colorgray2">
            <tr>
              <th>Titulo</th>
              <th>Fecha de publicacion</th>
              <th>Fecha de Cierre</th>
              <th>Severidad</th>
              <th>Permanente</th>
              <th>Estatus</th>
              <th>Acciones</th>
            </tr>
          </thead>
          <tbody>
            {banners.length > 0 ? (
              bannersMostrar().map((banner, index) => (
                <tr key={banner.id} className="colorgray2">
                  <td
                    className={
                      index === 0 ? "" : index === banners.length - 1 ? "" : ""
                    }
                  >
                    {banner.titulo}
                  </td>
                  <td>{moment(banner.inicio).format("DD/MM/YYYY hh:mm:ss")}</td>
                  <td>{moment(banner.fin).format("DD/MM/YYYY  hh:mm:ss")}</td>
                  <td>{banner.severidad}</td>
                  <td>
                    <Form.Check
                      disabled
                      type="switch"
                      label="Permanente"
                      checked={banner.permanente}
                    />
                  </td>

                  <td>
                    <Form.Check
                      disabled
                      type="switch"
                      label={banner.estatus == "1" ? "Activo" : "Inactivo"}
                      checked={banner.estatus == "1" ? true : false}
                    />
                  </td>
                  <td
                    className={
                      index === 0 ? "" : index === banners.length - 1 ? "" : ""
                    }
                    width="210"
                  >
                    <Button
                      variant="secondary"
                      className="btntable me-2"
                      onClick={() => borrarBanner(banner.id)}
                    >
                      <div className="material-icons">delete</div>
                    </Button>
                    <Link to={"/banners/" + banner.id}>
                      <Button variant="secondary" className="btntable me-2">
                        <div className="material-icons">edit</div>
                      </Button>
                    </Link>

                    <Button
                    
                      variant="secondary"
                      className="btntable"
                      onClick={() => activarDesactivar(banner.id)}
                    >
                      <div className="material-icons">
                        {banner.estatus == "1" ?'visibility_off':'visibility'}
                        
                        </div>
                    </Button>
                  </td>
                </tr>
              ))
            ) : cargado ? (
              <tr className="colorgray2">
                <td className="nodatos    " colSpan={5}>
                  No Existen Datos
                </td>
              </tr>
            ) : (
              <tr></tr>
            )}
          </tbody>
        </Table>
        <Row>
          <Paginador
            tamanoPagina={PAGE_SIZE}
            totalRegistros={banners.length}
            paginaCambiada={cambiarPagina}
          ></Paginador>
        </Row>
      </div>
    </>
  );
};
